export default __webpack_public_path__ + "static/media/trusted-by-moma.b6d81b06.png";